var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.8 18.4c0 10.162-8.238 18.4-18.4 18.4C8.238 36.8 0 28.562 0 18.4 0 8.238 8.238 0 18.4 0c10.162 0 18.4 8.238 18.4 18.4z",
    transform: "translate(-951 -1553) translate(952 1554)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.499 17.948L17.916 25.365 26.499 10.507",
    transform: "translate(-951 -1553) translate(952 1554)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarn);
export default __webpack_public_path__ + "static/media/earn.ce8835302cc012dff5086e27b8443677.svg";
export { ForwardRef as ReactComponent };